import { render, staticRenderFns } from "./TabsLink.vue?vue&type=template&id=a632e666&"
import script from "./TabsLink.vue?vue&type=script&lang=js&"
export * from "./TabsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports